import { FC } from 'react';
import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { Private } from '#/containers/router/routes/Private';
import { useI18n } from '#hooks/useI18n';
import { SectionProps } from '#/containers/asideNavigation/Sections';

interface AgentsProps extends SectionProps {
}

export const Agents: FC<AgentsProps> = ({ onClickItem, isMobile, depth }) => {
  const { t } = useI18n();

  return <Can hasRoles={['buildingManager', 'admin']}>
    <NavigationLink
      to={Private.AGENTS.route}
      onClick={onClickItem}
      icon="agent"
      title={t('general.agents')}
      isMobile={isMobile}
      depth={depth}
    />
  </Can>;
};
